import React from 'react'
import { Typography } from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next'

type AddedImagesListPropTypes = {
  images: ImageReturnType[]
  imagesUploading: File[]
  deleteImage: (id: string) => void
}

const AddedImagesList: React.FC<AddedImagesListPropTypes> = ({ images, imagesUploading, deleteImage }) => {
  const { t } = useTranslation()
  return (
    <>
      {(imagesUploading.length > 0 || images.length > 0) && (
        <Typography variant="body2" color="textSecondary">
          {t('images')}
        </Typography>
      )}

      {images.length > 0 && (
        <List dense={true}>
          {images.map((image) => (
            <ListItem key={image.id}>
              <ListItemText primary={image.originalName} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={(): void => deleteImage(image.id)} size="large">
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}
      {imagesUploading.length > 0 && (
        <List dense={true}>
          {imagesUploading.map((document) => (
            <ListItem key={document.name}>
              <ListItemText primary={document.name} />
              <ListItemSecondaryAction>
                <CircularProgress size={24} />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}
    </>
  )
}

export default AddedImagesList
